export default __webpack_public_path__ + "static/media/WhitneySSm-Book-Adv_Web.c3e40b22.woff2";